import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import logger from "../../../../../utils/logger";
import { getUser, loadUser } from "../../../../controller/reducer/user";

const LogoutModal = ({ onClose, logout }) => {
  const [activity, setActivity] = useState(null);
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  logger()(user)

  useEffect(() => {
    if (user.activity) {
      const addAccept = user.activity.numAddAccepted;
      const addReject = user.activity.numAddRejected;
      const editAccept = user.activity.numEditAccepted;
      const editReject = user.activity.numEditRejected;
      const addTotal = addAccept + addReject;
      const editTotal = editAccept + editReject;
      setActivity({
        add: {
          accept: {
            label: `${addAccept}/${addTotal}`,
            progress: Math.floor((addAccept / addTotal) * 100),
          },
          reject: {
            label: `${addReject}/${addTotal}`,
            progress: 100 - Math.floor((addAccept / addTotal) * 100),
          },
        },
        edit: {
          accept: {
            label: `${editAccept}/${editTotal}`,
            progress: Math.floor((editAccept / editTotal) * 100),
          },
          reject: {
            label: `${editReject}/${editTotal}`,
            progress: 100 - Math.floor((editAccept / editTotal) * 100),
          },
        },
      });
    } else setActivity(null);
  }, [user.activity]);

  useEffect(() => {
    dispatch(loadUser());
  }, []);

  return (
    <Modal show={true} animation={false} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="h5 font-weight-light">
          <strong>Name:</strong> {user.name} <br /> <strong>Type:</strong>{" "}
          {user.type}
          <br /> <strong>Email:</strong> {user.email} <br />{" "}
          <strong>Joined:</strong> {moment(user.joinedAt).fromNow()}
        </p>

        {activity !== null && (
          <div>
            <p className="h5 font-weight-normal">Activity</p>
            <p className="mt-1 mb-0 font-weight-normal">Add Request Reviews</p>
            <p className=" mb-0 text-muted">
              {activity.add.accept.label} accept(s) and{" "}
              {activity.add.reject.label} reject(s)
            </p>
            <ProgressBar>
              {activity.add.accept.progress > 0 && (
                <ProgressBar
                  striped
                  variant="success"
                  now={activity.add.accept.progress}
                  key={1}
                />
              )}
              {activity.add.reject.progress > 0 && (
                <ProgressBar
                  striped
                  variant="danger"
                  now={activity.add.reject.progress}
                  key={2}
                />
              )}
            </ProgressBar>
            <p className="mt-1 mb-0 font-weight-normal">Edit Request Reviews</p>
            <p className=" mb-0 text-muted">
              {activity.edit.accept.label} accept(s) and{" "}
              {activity.edit.reject.label} reject(s)
            </p>
            <ProgressBar>
              {activity.edit.accept.progress > 0 && (
                <ProgressBar
                  striped
                  variant="success"
                  now={activity.edit.accept.progress}
                  key={1}
                />
              )}
              {activity.edit.reject.progress > 0 && (
                <ProgressBar
                  striped
                  variant="danger"
                  now={activity.edit.reject.progress}
                  key={2}
                />
              )}
            </ProgressBar>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={logout}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
